module.exports = __webpack_public_path__ + "static/media/burger.49e94dfc.png";